document.addEventListener('turbo:load', () => {
  const propertiesTable = document.querySelector('.properties-table');
  const propertyProfile = document.querySelector('.property-profile');
  if (propertiesTable || propertyProfile) {
    const pageContent = document.querySelector('.page-content');
    const modalButtons = document.querySelectorAll('[data-modal="#building_info_modal"]');
    const modal = document.querySelector('.sync-modal');

    modalButtons.forEach((button) => {
      button.addEventListener('click', () => {
        pageContent.classList.add('fixed');
      });
    });

    function observeClass(mutationList, observer) {
      mutationList.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (!modal.classList.contains('active')) {
            pageContent.classList.remove('fixed');
          }
        }
      });
    }

    const observer = new MutationObserver(observeClass);

    observer.observe(modal, { attributes: true });
  }
});
